// extracted by css-extract-rspack-plugin
export default {"cls1":"SimplePaperPodcast-cls1_cb4","cls2":"SimplePaperPodcast-cls2_6R2 SimplePaperPodcast-cls1_cb4"};